/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { combineEpics } from 'redux-observable';
import { loginInspectorEpic, loginOperatorEpic, loginTaxpayerEpic } from './userEpics';
import { getCompaniesListEpic, companiesListDownloadEpic } from './companiesEpics';
import {
    getCompanyDetailsEpic,
    getCompanyStoresListEpic,
    getCompanyCashBoxesStatsEpic,
    getCompanyTurnoversByPeriodEpic,
    getCompanyTurnoversByObjectsEpic,
    companyTurnoversByPeriodDownloadEpic,
    companyTurnoversByObjectsDownloadEpic,
} from './companyDetailsEpics';
import {
    cashBoxesListDownloadEpic,
    fetchCashBoxesEpic,
    fetchCashRegisterVersionsListEpic,
} from './CashBoxRegistry/cashBoxesEpics';
import {
    fetchCashBoxDetailsEpic,
    changeCashBoxStatusEpic,
    blockCashBoxEpic,
    unblockCashBoxEpic,
    removeBlockUnblockScheduleCashBoxEpic,
    fetchCashBoxPeriodTurnoversEpic,
    cashBoxTurnoversDownloadEpic,
} from './CashBoxRegistry/cashBoxDetailsEpics';
import { getOperatorsListEpic, operatorsListDownloadEpic } from './operatorsEpics';
import {
    fetchOperatorDetailsEpic,
    fetchOperatorCashBoxesStatsEpic,
    fetchOperatorCashRegistersEpic,
} from './operatorsDetailsEpics';
import { getStoresListEpic, storesListDownloadEpic } from './storesEpics';
import {
    getStoreDetailsEpic,
    updateStoreInfoEpic,
    getStoreCashboxesListEpic,
    getStoreCashBoxesStats,
    fetchCoordinatesHistoryEpic,
    coordinatesHistoryDownloadEpic,
    fetchInspectionsHistoryEpic,
    createInspectionEpic,
    cancelInspectionEpic,
    assignInspectionEpic,
    completeInspectionEpic,
    getStoreTurnoversByPeriodEpic,
    getStoreTurnoversByCashBoxesEpic,
    storeTurnoversByPeriodDownloadEpic,
    storeTurnoversByCashBoxesDownloadEpic,
    getStorePhotosInfoEpic,
    uploadPhotosEpic,
    deleteStorePhotosEpic,
    setOnPreviewEpic,
} from './storeDetailsEpics';
import { fetchAlertsEpic, fetchNewAlertsByIntervalEpic, updateAlertsEpic } from './alertsEpic';
import { fetchAggregatesEpic, aggregatesReportDownloadEpic } from './reportsEpic';
import {
    fetchAlertItemsEpic,
    updateAlertItemEpic,
    reportLoadEpic,
    fetchAlertDetails,
    updateAlertDetailsEpic,
} from './alertsDetailsEpick';
import {
    paymentTypesStatEpic,
    turnoversByActivitiesEpic,
    registryItemsCountInfoEpic,
    finChartsDataDownloadEpic,
} from './dashBoardFinEpics';
import {
    fetchDocumentsStatEpic,
    cashBoxesStatEpic,
    operatorsCashBoxesEpic,
    docsCountsStatEpic,
    devicesCountsEpic,
    techChartsDataDownloadEpic,
} from './dashBoardTechEpics';
import { fetchCashRegistersEpic, cashRegistersListDownloadEpic } from './cashRegisterModelsEpics';
import {
    fetchCashRegisterModelDetailsEpic,
    updateModelEpic,
    startAttestationEpic,
    completeAttestationEpic,
    fetchSoftwareVersionsListEpic,
    fetchVersionCheckSumsEpic,
    activateModelEpic,
    eliminateModelEpic,
    activateVersionEpic,
    markVersionOutdatedEpic,
    fetchDocumentsListEpic,
    submitDocumentsEpic,
    downloadDocumentEpic,
    deleteDocumentsEpic,
    fetchFactoryNumbersListEpic,
} from './cashRegisterModelDetailsEpics';
import { fetchAlertsTemplatesEpic, updateAlertTemplateEpic } from './alertsSettingsEpic';
import { fetchAlertsExecutionsEpic, fetchAlertsExecutionsByInterval } from './alertsExecutionsEpic';
import { fetchOperatorAccDetailsEpic, fetchOperatorAccCashBoxesStatsEpic } from './OperatorAcc/operatorAccHomeEpics';
import { fetchMapStoresEpic } from './EStoreMap';
import {
    fetchCashRegisterModelsListEpic,
    fetchFirmwareVersionsListEpic,
    fetchOperatorsShortListEpic,
    fetchStoreTypesEpic,
    fetchCompanyActivitiesEpic,
    fetchTaxationTypesListEpic,
    fetchTaxAuthoritiesListEpic,
    fetchCitiesListEpic,
    fetchAlertAssigneeUsersListEpic,
    fetchRegionsListEpic,
    fetchFiscalDriverVersionsListEpic,
    fetchMainActivitiesListEpic,
    fetchMiddleActivitiesListEpic,
    fetchLowerActivitiesListEpic,
} from './EShortLists';
import { fetchUserInfoEpic, updateUserInfoEpic } from './settingsUserInfoEpics';
import { changeUserPasswordEpic } from './settingsSecurityEpics';
import {
    getUsersListEpic,
    usersListDownloadEpic,
    editUserEpic,
    blockUserEpic,
    unblockUserEpic,
    deleteUserEpic,
    addUserEpic,
    refreshUsersListEpic,
} from './adminUsersEpics';
import {
    fetchDocumentsListPageEpic,
    fetchDocumentsExtendedDataEpic,
    downloadDocumentsListEpic,
} from './documentsEpics';
import { fetchDocumentCardDetailsEpic } from './documentDetailsEpic';
import { fetchDocumentPictEpic } from './documentDetailsPictEpics';
import { fetchDevicesListPageEpic, downloadDevicesListEpic } from './devicesEpics';
import {
    getDeviceDetailsEpic,
    fetchFirmwareHistoryEpic,
    firmwareHistoryDownloadEpic,
    fetchStatusHistoryEpic,
    statusHistoryDownloadEpic,
    fetchOperatorHistoryEpic,
    operatorHistoryDownloadEpic,
    fetchRegistrationHistoryEpic,
    registrationHistoryDownloadEpic,
} from './deviceDetails.Epics';
import { fetchCashBoxesForMapEpic } from './ECashBoxesMap';
import {
    getDelayedDownloadingsListEpic,
    delayedDownloadingsPollingEpic,
    deleteDelayedDownloadingsListItemEpic,
    downloadFileFromDelayedDownloadingsListEpic,
} from './downloadingsEpics';
import { getTaxpayerAccCashBoxesStatsEpic, getTaxpayerAccDetailsEpic } from './TaxpayerAcc/taxpayerAccHomeEpics';
import {
    fetchCertUpdatesHistoryEpic,
    requestCertUpdateEpic,
    fetchCashBoxLogsHistoryEpic,
    requestCashBoxLogsEpic,
    downloadCashBoxLogsFileEpic,
    fetchFirmwareUpdatesHistoryEpic,
    requestFirmwareUpdateEpic,
    fetchSuitableFirmwareTargetVersionsEpic,
    fetchEnvInfoHistoryEpic,
    requestEnvInfoEpic,
} from './CashBoxRegistry/Tabs/cashBoxTasksTabEpics';
import {
    cashBoxStateHistoryDownloadEpic,
    fetchCashBoxStateHistoryEpic,
} from './CashBoxRegistry/Tabs/cashBoxStateTabEpics';
import {
    fetchCashBoxStatusHistoryEpic,
    cashBoxStatusHistoryDownloadEpic,
} from './CashBoxRegistry/Tabs/cashBoxStatusTabEpics';
import {
    fetchCashBoxTimeDeltaHistoryEpic,
    cashBoxTimeDeltaHistoryDownloadEpic,
} from './CashBoxRegistry/Tabs/cashBoxTimeDeltaTabEpics';
import {
    fetchCashBoxAuditHistoryEpic,
    cashBoxAuditHistoryDownloadEpic,
} from './CashBoxRegistry/Tabs/cashBoxAuditTabEpics';
import {
    fetchCashBoxAlertsHistoryEpic,
    cashBoxAlertsHistoryDownloadEpic,
} from './CashBoxRegistry/Tabs/cashBoxAlertsTabEpics';
import {
    fetchCashBoxReplacementHistoryEpic,
    cashBoxReplacementHistoryDownloadEpic,
} from './CashBoxRegistry/Tabs/cashBoxReplacementTabEpics';
import {
    getCashBoxLocationDataEpic,
    getHistoryLocationsPageEpic,
    getGpsTrackingListEpic,
} from './CashBoxRegistry/Tabs/cashBoxGpsTrackingTabEpics';
import { fetchCashBoxCheckSumsHistoryEpic } from './CashBoxRegistry/Tabs/cashBoxCheckSumsTabEpics';
import {
    fetchCashBoxDocumentsEpic,
    fetchDocumentsByIntervalEpic,
    cashBoxDocsDownloadEpic,
} from './CashBoxRegistry/Tabs/cashBoxDocumentsTabEpics';
import { fetchCashBoxLastDocumentEpic } from './CashBoxRegistry/Tabs/cashBoxLastDocumentTabEpics';
import {
    addRulesEpic,
    deleteRulesEpic,
    editRuleEpic,
    getAlertTemplateRulesEpic,
    getAlertTemplatesRuleIdentifiersEpic,
    sampleRulesDownloadEpic,
    templateRulesDownloadEpic,
} from './EAlertTemplateRules';
import { fetchCashboxStatisticsEpic, fetchCashboxStatisticsByIntervalEpic } from './statisticsEpics';
import {
    fetchRoughCashBoxesListEpic,
    updateServiceCashBoxesListEpic,
    createCashboxTasksEpic,
    getCashboxesTasksStatusEpic,
    updateCashboxesTasksStatusOnCreateTasksSuccessEpic,
    fetchSuitableFwTargetVersionsEpic,
    downloadCashBoxLogsZipFileEpic,
    fetchDevicesListEpic,
    performDevicesOperation,
    searchFactoryNumbersListEpic,
    uploadInitialisationTabFileEpic,
} from './serviceEpics';
import {
    createInitOtpEpic,
    fetchCashRegisterDetailsEpic,
    fetchCashRegisterStatusHistoryEpic,
} from './cashRegisterDetailsEpics';
import { fetchCashRegistersListEpic } from './cashRegisterEpics';
import { RootState } from 'data/store.typings';

export const rootEpic = combineEpics<any, any, RootState>(
    loginInspectorEpic,
    loginOperatorEpic,
    loginTaxpayerEpic,
    getTaxpayerAccDetailsEpic,
    getTaxpayerAccCashBoxesStatsEpic,
    getCompaniesListEpic,
    getCompanyDetailsEpic,
    getCompanyStoresListEpic,
    getOperatorsListEpic,
    operatorsListDownloadEpic,
    fetchOperatorDetailsEpic,
    fetchOperatorCashBoxesStatsEpic,
    fetchOperatorCashRegistersEpic,
    getStoreCashboxesListEpic,
    getStoreCashBoxesStats,
    fetchCoordinatesHistoryEpic,
    coordinatesHistoryDownloadEpic,
    fetchInspectionsHistoryEpic,
    createInspectionEpic,
    cancelInspectionEpic,
    assignInspectionEpic,
    completeInspectionEpic,
    getStoresListEpic,
    getStoreDetailsEpic,
    updateStoreInfoEpic,
    fetchCashBoxesEpic,
    fetchCashBoxDetailsEpic,
    changeCashBoxStatusEpic,
    blockCashBoxEpic,
    unblockCashBoxEpic,
    removeBlockUnblockScheduleCashBoxEpic,
    fetchCashBoxDocumentsEpic,
    fetchDocumentsByIntervalEpic,
    fetchCashBoxLastDocumentEpic,
    fetchCashBoxStatusHistoryEpic,
    fetchCashBoxTimeDeltaHistoryEpic,
    fetchCashBoxStateHistoryEpic,
    fetchCashBoxAuditHistoryEpic,
    fetchCashBoxReplacementHistoryEpic,
    fetchCashBoxAlertsHistoryEpic,
    fetchAlertsEpic,
    fetchAlertItemsEpic,
    reportLoadEpic,
    updateAlertDetailsEpic,
    updateAlertItemEpic,
    fetchNewAlertsByIntervalEpic,
    updateAlertsEpic,
    fetchAggregatesEpic,
    aggregatesReportDownloadEpic,
    cashBoxDocsDownloadEpic,
    cashBoxStateHistoryDownloadEpic,
    cashBoxStatusHistoryDownloadEpic,
    cashBoxReplacementHistoryDownloadEpic,
    cashBoxTimeDeltaHistoryDownloadEpic,
    cashBoxAuditHistoryDownloadEpic,
    cashBoxAlertsHistoryDownloadEpic,
    fetchCashBoxPeriodTurnoversEpic,
    cashBoxTurnoversDownloadEpic,
    getCompanyTurnoversByPeriodEpic,
    getCompanyTurnoversByObjectsEpic,
    companyTurnoversByPeriodDownloadEpic,
    companyTurnoversByObjectsDownloadEpic,
    getStoreTurnoversByPeriodEpic,
    getStoreTurnoversByCashBoxesEpic,
    storeTurnoversByPeriodDownloadEpic,
    getStorePhotosInfoEpic,
    uploadPhotosEpic,
    setOnPreviewEpic,
    deleteStorePhotosEpic,
    storeTurnoversByCashBoxesDownloadEpic,
    fetchDocumentsStatEpic,
    paymentTypesStatEpic,
    cashBoxesStatEpic,
    turnoversByActivitiesEpic,
    operatorsCashBoxesEpic,
    registryItemsCountInfoEpic,
    finChartsDataDownloadEpic,
    docsCountsStatEpic,
    devicesCountsEpic,
    techChartsDataDownloadEpic,
    fetchCashRegistersEpic,
    cashRegistersListDownloadEpic,
    fetchCashRegisterModelDetailsEpic,
    updateModelEpic,
    startAttestationEpic,
    completeAttestationEpic,
    fetchSoftwareVersionsListEpic,
    fetchVersionCheckSumsEpic,
    activateModelEpic,
    eliminateModelEpic,
    activateVersionEpic,
    markVersionOutdatedEpic,
    fetchDocumentsListEpic,
    fetchDocumentCardDetailsEpic,
    fetchDocumentPictEpic,
    submitDocumentsEpic,
    downloadDocumentEpic,
    deleteDocumentsEpic,
    fetchFactoryNumbersListEpic,
    fetchAlertsTemplatesEpic,
    updateAlertTemplateEpic,
    fetchAlertsExecutionsEpic,
    fetchAlertsExecutionsByInterval,
    fetchOperatorAccDetailsEpic,
    fetchOperatorAccCashBoxesStatsEpic,
    fetchMapStoresEpic,
    cashBoxesListDownloadEpic,
    storesListDownloadEpic,
    companiesListDownloadEpic,
    fetchAlertDetails,
    getCompanyCashBoxesStatsEpic,
    fetchStoreTypesEpic,
    fetchCompanyActivitiesEpic,
    fetchCashRegisterModelsListEpic,
    fetchOperatorsShortListEpic,
    fetchFirmwareVersionsListEpic,
    fetchFiscalDriverVersionsListEpic,
    fetchTaxAuthoritiesListEpic,
    fetchTaxationTypesListEpic,
    fetchCitiesListEpic,
    fetchAlertAssigneeUsersListEpic,
    fetchUserInfoEpic,
    updateUserInfoEpic,
    changeUserPasswordEpic,
    getUsersListEpic,
    usersListDownloadEpic,
    editUserEpic,
    blockUserEpic,
    unblockUserEpic,
    deleteUserEpic,
    addUserEpic,
    refreshUsersListEpic,
    fetchDocumentsListPageEpic,
    fetchDocumentsExtendedDataEpic,
    downloadDocumentsListEpic,
    fetchDevicesListPageEpic,
    downloadDevicesListEpic,
    getDeviceDetailsEpic,
    fetchFirmwareHistoryEpic,
    firmwareHistoryDownloadEpic,
    fetchStatusHistoryEpic,
    statusHistoryDownloadEpic,
    fetchOperatorHistoryEpic,
    operatorHistoryDownloadEpic,
    fetchRegistrationHistoryEpic,
    registrationHistoryDownloadEpic,
    fetchCashBoxesForMapEpic,
    getCashBoxLocationDataEpic,
    getHistoryLocationsPageEpic,
    getGpsTrackingListEpic,
    fetchCashBoxCheckSumsHistoryEpic,
    getDelayedDownloadingsListEpic,
    delayedDownloadingsPollingEpic,
    deleteDelayedDownloadingsListItemEpic,
    downloadFileFromDelayedDownloadingsListEpic,
    fetchCertUpdatesHistoryEpic,
    requestCertUpdateEpic,
    fetchCashBoxLogsHistoryEpic,
    requestCashBoxLogsEpic,
    downloadCashBoxLogsFileEpic,
    getAlertTemplateRulesEpic,
    addRulesEpic,
    editRuleEpic,
    deleteRulesEpic,
    templateRulesDownloadEpic,
    fetchFirmwareUpdatesHistoryEpic,
    requestFirmwareUpdateEpic,
    fetchSuitableFirmwareTargetVersionsEpic,
    fetchEnvInfoHistoryEpic,
    requestEnvInfoEpic,
    sampleRulesDownloadEpic,
    getAlertTemplatesRuleIdentifiersEpic,
    fetchCashRegisterVersionsListEpic,
    fetchRegionsListEpic,
    fetchCashboxStatisticsEpic,
    fetchCashboxStatisticsByIntervalEpic,
    fetchRoughCashBoxesListEpic,
    updateServiceCashBoxesListEpic,
    fetchSuitableFwTargetVersionsEpic,
    createCashboxTasksEpic,
    getCashboxesTasksStatusEpic,
    updateCashboxesTasksStatusOnCreateTasksSuccessEpic,
    uploadInitialisationTabFileEpic,
    searchFactoryNumbersListEpic,
    fetchDevicesListEpic,
    performDevicesOperation,
    downloadCashBoxLogsZipFileEpic,
    fetchMainActivitiesListEpic,
    fetchMiddleActivitiesListEpic,
    fetchLowerActivitiesListEpic,
    fetchCashRegisterDetailsEpic,
    createInitOtpEpic,
    fetchCashRegistersListEpic,
    fetchCashRegisterStatusHistoryEpic,
);
